/* eslint-disable no-restricted-imports */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigAssetLoaderService } from '../../../services/config-asset-loader.service';
import { LoginService } from '../../../services/login.service';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { CommonFuntions } from '../../../common/common.function';
import { get } from 'lodash';

declare let $: any;

@Component({
  selector: 'app-partner-role',
  templateUrl: './partner-role.component.html',
  styleUrls: ['./partner-role.component.css']
})
export class PartnerRoleComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: true})
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  token = 'Bearer ' + localStorage.getItem('token');
  valueToSearch: string;
  errorString: string;

  title: string;
  searchValue: string;
  userCount: number
  activeUsers: number
  inactiveUsers: number

  constructor(
    public router: Router,
    private loginService: LoginService
  ) {
    this.userCount = 0;
  }

  ngOnInit() {
    this.title = 'Partner Role';
    const user = this.loginService.getCurrentUser();
    const url = ConfigAssetLoaderService.getApiURL() + '/user/role/3?type=' + user.user_type.type + '&userid=' + user.user_id;
    const optionObject = {
      ajax: {
        url: url,
        dataSrc: function(json) {
          this.userCount = json.recordsTotal;
          this.activeUsers = json.activeCount || 0;
          this.inactiveUsers = json.inActiveCount || 0;
          return json.data;
        }.bind(this),
        type: 'POST',
        beforeSend: function (xhr) {
          if (!CommonFuntions.guardForAction(this.loginService, this.router)) {
            xhr.abort();
            return;
          }

          this.errorString = null;
          const token = localStorage.getItem('token');
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        }.bind(this),
        error: this.datatablesError.bind(this)
      },
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: true,
      stateSave: true,
      stateDuration: 5 * 60,
      pageLength: 25,
      order: [[0, 'ASC']],
      info: false,
      rowCallback: (row: Node, data: any[] | Object, _index: number) => {
        // Unbind first in order to avoid duplicate handler
        $('td', row).unbind('click');
        $('td', row).bind('click', function () {
          this.viewUserInfo(data);
        }.bind(this));
      }
    };

    optionObject['columns'] = this.getColumn(user);

    this.dtOptions = optionObject;

    this.setSearchValueFromSavedState();
  }

  datatablesError(xhr, _error, _thrown) {
    const errorStatus = xhr.status;
    if (errorStatus == 401) {
      this.router.navigate(['/login']);
    }
    else if (errorStatus == 404) {
      this.errorString = 'Invalid Url';
    }
    else {
      this.errorString = 'Problem occurred. Please contact your administrator';
    }
  }

  search() {
    this.datatableElement.dtInstance.then(
      (dtInstance: DataTables.Api) => {
        dtInstance.search(this.valueToSearch).draw();
      }
    );
  }

  searchString(searchValue: string) {
    this.valueToSearch = searchValue;
    this.search();
  }

  viewUserInfo(info: any) {
    // if(this.user)
    this.router.navigate(['/profile', info.user_id]);

  }

  private getColumn(user: any) {
    let columns;

    if (user.user_type.type.toLowerCase() === 'admin' || user.user_type.type.toLowerCase() === 'cmmanager' ||
      user.user_type.type.toLowerCase() === 'careteam') {
      columns = [
        {
          title: 'Company',
          render: function (_data, _type, row, _meta) {
            if (row.user_partners.length < 1) {
              return '';
            }

            let partnerList = '';
            const partnerArray = [];
            const morePartnerArray = [];

            row.user_partners.forEach(eachPartner => {
              const partnerCount = partnerArray.length;

              if (partnerCount < 5) {
                if(get(eachPartner, 'partner.partner_name')){
                  partnerArray.push(eachPartner?.partner?.partner_name);
                  partnerList = partnerList + '<li>' + $.fn.dataTable.render.text().display(eachPartner?.partner?.partner_name) + '</li>';
                }
              }
              else {
                if (morePartnerArray.length === 0) {
                  partnerList = partnerList + '<span class="text text--dark-grey">More ...</span>';
                }
                morePartnerArray.push(true);
              }
            });

            if (row.is_all_partners) {
              if (row.is_all_partners == 1) {
                return '<div style="width: 150px">All Clients</div>';
              }
              else if (row.is_all_partners == 2) {
                return '<div style="width: 150px">All Ally Clients</div>';
              }
              else if (row.is_all_partners == 3) {
                return '<div style="width: 150px">All Non-Ally Clients</div>';
              }
            }

            // return '<div title="' + partnerArray.toString() + '"><ul>' + partnerList + '</ul></div>';
            return '<div title="' + $.fn.dataTable.render.text().display(partnerArray.join(String.fromCharCode(13)).toString()) + '">' + row.user_partners.length + ' Clients</div>';
          }
        },
        {
          title: 'Name',
          render: function (_data, _type, row, _meta) {
            const fullName = $.fn.dataTable.render.text().display(row.full_name);
            const allyUserRef = $.fn.dataTable.render.text().display(row.allyUserRef || '');
            const nameText = row.allyUserRef ? fullName + '<br /> Ref:' + allyUserRef : fullName;

            if (row.is_all_partners) {
              if (row.is_all_partners == 1) {
                return `<div style="width:150px;">${nameText} <span class="badge-small badge-secondary" title="All Clients">All</span></div>`;
              }
              else if (row.is_all_partners == 2) {
                return `<div style="width:150px;">${nameText} <span class="badge-small badge-yellow" title="All Ally Clients">Ally</span></div>`;
              }
              else if (row.is_all_partners == 3) {
                return `<div style="width:150px;">${nameText} <span class="badge-small badge-orange" title="All Non-ally Clients">Cloud</span></div>`;
              }
            }
            return `<div style="width:150px;">${nameText}</div>`;
          }
        },
        {
          title: 'Phone Number',
          render: function (_data, _type, row, _meta) {
            if (!row.phone_number || row.phone_number === '') {
              return '';
            }

            return $.fn.dataTable.render.text().display(row.phone_number);
          }
        },
        {
          title: 'Email',
          render: function (_data, _type, row, _meta) {
            return $.fn.dataTable.render.text().display(row.email);
          }
        },
        {
          title: 'Status',
          render: function (_data, _type, row, _meta) {
            if (row.is_deleted) {
              return 'Inactive';
            }
            else {
              return 'Active';
            }
          },
          orderable: false
        }
      ];
    }
    else if (user.user_type.type.toLowerCase() === 'partner') {
      columns = [
        {
          title: 'Name',
          render: function (_data, _type, row, _meta) {
            return $.fn.dataTable.render.text().display(row.full_name);
          }
        },
        {
          title: 'Phone Number',
          render: function (_data, _type, row, _meta) {
            if (!row.phone_number || row.phone_number === '') {
              return '';
            }

            return $.fn.dataTable.render.text().display(row.phone_number);
          }
        },
        {
          title: 'Email',
          render: function (_data, _type, row, _meta) {
            return $.fn.dataTable.render.text().display(row.email);
          }
        }
      ];
    }

    return columns;
  }

  setSearchValueFromSavedState() {

    const state = localStorage.getItem('DataTables_client_careteam_/client-role');

    if (state == null) {
      this.searchValue = '';
      return;
    }

    const searchValue = JSON.parse(state).search['search'];

    if (searchValue != null) {

      this.searchValue = searchValue;

    }
  }

}
